import { authHeaders } from './headers';
import { apiUrl } from './http';

const BASE = '/api/forklifts';

function toJsonSafe(res) {
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : Promise.resolve(null);
}

export async function listForklifts() {
  try {
    const res = await fetch(apiUrl(BASE), { headers: authHeaders() });
    const data = await toJsonSafe(res);
    return { ok: res.ok, status: res.status, data: Array.isArray(data) ? data : [] };
  } catch (e) {
    return { ok: false, status: 0, data: [], error: String(e) };
  }
}

export async function createForklift(payload) {
  try {
    const res = await fetch(apiUrl(BASE), {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await toJsonSafe(res);
    return { ok: res.ok, status: res.status, data };
  } catch (e) {
    return { ok: false, status: 0, data: null, error: String(e) };
  }
}

export async function removeForklift(id) {
  try {
    const res = await fetch(apiUrl(`${BASE}/${id}`), {
      method: 'DELETE',
      headers: authHeaders(),
    });
    return { ok: res.ok, status: res.status };
  } catch (e) {
    return { ok: false, status: 0, error: String(e) };
  }
}

export async function updateForkliftStatus(id, status, options = {}) {
  try {
    const res = await fetch(apiUrl(`${BASE}/${id}/status`), {
      method: 'PATCH',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ status, ...options }),
    });
    const data = await toJsonSafe(res);
    return { ok: res.ok, status: res.status, data };
  } catch (e) {
    return { ok: false, status: 0, data: null, error: String(e) };
  }
}
